import React from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import "./index.scss";
import Header from "../../components/appLayout/header";
import { LinkIconb } from "../../assets/icons/LinkIconb";
import { LocalisationIcon } from "../../assets/icons/LocalisationIcon";
import { EmailIcon } from "../../assets/icons/EmailIcon";
import { PhoneIcon } from "../../assets/icons/PhoneIcon";
import { useState } from "react";
import { toast } from "react-toastify";
import { useTranslation } from "../../hooks/useTranslation";
export default function ContactSection() {
  const { t } = useTranslation();
  const contactRecipientEmail = "contact@spotin-france.fr";
  const mapAddress = "54 rue du Général de Gaulle, Belhomert-Guéhouville, France, 28240";
  const mapSrc = `https://maps.google.com/maps?q=${encodeURIComponent(mapAddress)}&t=&z=15&ie=UTF8&iwloc=&output=embed`;
  const [formData, setFormData] = useState({
    nom: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://api.spot-in.msit-demo.fr/api/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...formData,
          recipientEmail: contactRecipientEmail,
        }),
      });

      if (response.ok) {
        toast.success(t('contact.success'));
        setFormData({
          nom: "",
          email: "",
          phone: "",
          message: "",
        });
      } else {
        const errorData = await response.json();
        console.error("Erreur serveur :", errorData);
        toast.error(t('contact.error'));
      }
    } catch (error) {
      console.error("Erreur réseau :", error);
      toast.error(t('contact.networkError'));
    }
  };
  return (
    <>
      <Header />
      <section className="contact-section">
        <Container>
          {/* <div className="d-flex flex-column flex-md-row justify-content-between align-items-start mb-3">
            <h2 className="section-title">{t('contact.title')}</h2>
            <button className="btn-contact">
              MSITCORPORATE.COM <LinkIconb />
            </button>
          </div> */}
          <Row className="contact-top">
            {/* Formulaire */}
            <Col md={7} className="contact-form-col">
              <Form className="contact-form" onSubmit={handleSubmit}>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="nom">
                      <Form.Label>{t('contact.form.name')}</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder={t('contact.form.namePlaceholder')}
                        value={formData.nom}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="email">
                      <Form.Label>{t('contact.form.email')}</Form.Label>
                      <Form.Control
                        type="email"
                        placeholder={t('contact.form.emailPlaceholder')}
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Form.Group className="mb-3" controlId="phone">
                  <Form.Label>{t('contact.form.phone')}</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder={t('contact.form.phonePlaceholder')}
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="message">
                  <Form.Label>{t('contact.form.message')}</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    placeholder={t('contact.form.messagePlaceholder')}
                    value={formData.message}
                    onChange={handleChange}
                  />
                </Form.Group>
                <div className="d-flex justify-content-end align-items-center mb-3">
                  <Button className="btn-submit" type="submit">
                    {t('contact.form.submit')}
                  </Button>
                </div>
              </Form>
            </Col>

            {/* Informations contact */}
            <Col md={5} className="contact-info-col">
              <div className="contact-info">
                <h1 className="mb-3">{t('contact.info.title')}</h1>
                <div className="info-item mt-4">
                  <PhoneIcon />
                  <span>{t('contact.info.phone')}</span>
                </div>
                <div className="info-item mt-4">
                  <EmailIcon />
                  <span>{t('contact.info.email')}</span>
                </div>
                <div className="info-item mt-4">
                  <LocalisationIcon />
                  <span>{t('contact.info.address')}</span>
                </div>
              </div>
            </Col>
          </Row>

          {/* Carte */}
          <Row className="contact-map">
            <Col>
              <div className="map-container">
                {/* Ici tu peux intégrer Google Map ou iframe */}
                <iframe
                  title="location"
                  src={mapSrc}
                  width="100%"
                  height="300"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"></iframe>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
